import { useMutation } from '@tanstack/react-query'
import { postAddMerchant } from 'services/MerchantService'

export const usePostAddMerchantMutation = () => {
  return useMutation({ mutationFn: postAddMerchant })
}
